import { ref } from 'vue'

export const isAuthenticated = ref(false)
